class CarouselController {
  constructor (BannerService, VehicleService, DeviceService) {
    'ngInject'
    this.vehicleService = VehicleService
    this.bannerService = BannerService
    this.deviceService = DeviceService

    this.banners = []
    this.loaded = this.init()
  }

  init () {
    return this.vehicleService.getCurrentSelectedVehicle()
    .then((vehicle) => {
      this.vehicle = vehicle
      this.bannerService
      const params = {
        huType: vehicle.huType,
        display: this.deviceService.getAtcDeviceId(),
        vin: vehicle.vin
      }
      return this.bannerService.getBanners(params)
    })
    .then((data) => {
      this.banners = data.banners
      this.duration = data.duration
    })
  }

  getBannerUrl (banner, size) {
    if (banner.bannerUrl != null) {
      if (size === '') {
        return banner.bannerUrl
      } else {
        let extIdx = banner.bannerUrl.lastIndexOf('.')
        return (banner.bannerUrl.slice(0, extIdx) + '_' + size + banner.bannerUrl.slice(extIdx))
      }
    }
  }

}

export default CarouselController



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/catalog/components/carousel/carousel.controller.js